import styled from 'styled-components';

export const RestrictionFormContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
`;

export const RowRestrictionFormItemContainer = styled.div`
    display: flex;
    width: 100%;
    gap: 8px;
`;

export const FieldRestrictionFormItemContainer = styled.div`
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 8px;
`;

export const RestrictionFormItem = styled.div`
    margin: 0;
    flex-grow: 1;
`;

export const RestrictionTypeFormItem = styled.div`
    margin: 0;
    width: 100%;
`;

export const OperatorFormItem = styled.div`
    margin: 0;
    width: 120px;

    @media (max-width: 425px) {
        flex-grow: 1;
        flex-basis: 120px;
    }
`;

export const GrowFormItem = styled.div`
    margin: 0;
    flex-grow: 1;
    flex-basis: 125px;
`;

export const OrSeparator = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 8px 0;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        height: 1px;
        background-color: #d9d9d9;
        z-index: 1;
    }

    span {
        background-color: white;
        padding: 0 16px;
        color: #666;
        font-size: 12px;
        font-weight: 500;
        z-index: 2;
        position: relative;
    }
`;